try{self['workbox:background-sync:4.1.1']&&_()}catch(e){}// eslint-disable-line